/**
 * Debug utilities.
 * Use debugLog() for development-only logs; no-op when debugMode is off.
 */

const STORAGE_KEY = 'rychle-sipy-a-velikonocni-poklad:debugMode'

export function isDebugModeEnabled(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true'
  } catch {
    return false
  }
}

/** Log only when debug mode is enabled; no-op otherwise. */
export function debugLog(...args: unknown[]): void {
  if (isDebugModeEnabled()) {
    console.log(...args)
  }
}
